import axios from "axios";
import config from "../config";

export const uploadToAws = async (file, courseTitle) => {
  const fileName = `${courseTitle}-${file.name}`;
  const contentType = file.type;

  try {
    // Get the pre-signed URL
    const response = await axios.post(config.generatePresignedUploadUrl, {
      fileName: fileName,
      contentType: contentType
    });

    const { uploadUrl, fileAccessUrl } = response.data;

    // Upload to S3 using the pre-signed URL
    await axios.put(uploadUrl, file, {
      headers: {
        "Content-Type": contentType
      },
      skipAuthorizationHeader: true
    });

    return fileAccessUrl;
  } catch (error) {
    console.error("Error uploading file to AWS:", error);
    throw error;
  }
};
